import { isNull, isUndefined } from 'lodash';

/**
 * @name generateTableHead
 */
export const generateTableHead = () => [
  'All',
  'ID',
  'User',
  'Order ID',
  'Start count',
  'Quantity',
  'Current count',
  'To refill',
  'Service',
  'Status',
  'Created',
  'Mode',
  '',
];

/**
 * @name constants
 */
export const constants = {
  STATUS_PENDING: 1,
  STATUS_AWAITING: 2,
  STATUS_IN_PROGRESS: 3,
  STATUS_REJECTED: 4,
  STATUS_COMPLETED: 7,
};

/**
 * @name makeTableRow
 * @param item {Object} - Элемент для таблицы
 */
export const makeTableRow = (item) => [
  { value: '', type: 'checkbox' },
  { value: item.id, type: 'id' },
  { value: item.username, type: 'username' },
  { value: item.order_id, type: 'order_id' },
  { value: item.start_count, type: 'start_count', tooltipText: item.tooltipText },
  { value: item.quantity, type: 'quantity' },
  { value: item.current_count, type: 'current_count', tooltipText: item.tooltipText },
  {
    value:
      String(item.current_count).trim() !== '' && item.current_count !== null && Number(item.current_count) >= 0
        ? Number(item.start_count) + Number(item.quantity) - Number(item.current_count)
        : null,
    type: 'to_refill',
  },
  { value: item.service, type: 'service' },
  { value: item.status_name, type: 'status_name' },
  { value: item.created, type: 'created' },
  { value: item.mode_name, type: 'mode_name' },
  { value: '', type: 'actions' },
];

/**
 * @name massDropStatuses
 * @param statuses {Array} - Список всех статусов для страницы
 * @param tasks {Array} - Список элементов таблицы
 * @param t {Function} - Функция для переводов
 */
export const massDropStatuses = (statuses, tasks = [], t) => {
  const massSubmenuStatuses = [...new Set(tasks?.map((item) => item.access.change_status).flat())];
  return statuses?.filter((item) => massSubmenuStatuses.includes(item.id)).map((elem) => ({ id: elem.id, title: t(`ActionsList.${elem.title}`) }));
};

/**
 * @name generateAccessMassDrop
 * @param access {Object} - Список доступов для страницы
 * @param query {Object} - Объект параметров поиска страницы
 * @param t {Function} - Функция для переводов
 */
export const generateAccessMassDrop = (access = {}, t, query, statuses, tasks = []) => {
  const massDrops = massDropStatuses(statuses, tasks, t);

  const defaulMassActions = [
    access?.bulk_status
      && massDrops?.length > 0 && {
      title: t('ActionsList.Change status'),
      id: 1,
    },
    {
      title: t('ActionsList.Copy to clipboard'),
      id: 3,
    },
  ];

  return {
    defaulMassActions: defaulMassActions.filter((item) => !!item),
    massDropStatuses: massDrops,
  };
};

/**
 * @param access {Object} - Объект с параметрами true/false (Показываем или нет кнопки) у конкретного рефилла
 * @param fullAccess {Object} - Объект с параметрами true/false (Доступы из My.panel)
 * @param t {Function} - Функция для переводов
 * @returns {({defActionName: string, id: number, title: *}|{defActionName: string, id: number, title: *}|{defActionName: string, id: number, title: *}|{defActionName: string, id: number, title: *})[]}
 */
export const generateAccessItemDrop = (access = {}, fullAccess = {}, t) => {
  if (fullAccess?.details && access?.details) {
    access.details = true;
  }

  const defaultAccess = [
    {
      title: t('ActionsList.Details'),
      id: 1,
      defActionName: 'view',
    },
    {
      title: t('ActionsList.Change status'),
      id: 2,
      defActionName: 'change_status',
    },
    {
      title: t('ActionsList.Details for superadmin'),
      id: 5,
      defActionName: 'details',
    },
  ];

  const formatAccessActions = defaultAccess?.filter((item) => Object.keys(access)
    .filter((item) => access[item] && String(access[item]).length)
    .includes(item.defActionName));

  return formatAccessActions;
};

/**
 * @name itemDropStatuses
 * @param statuses {Array} - Список всех статусов для страницы
 * @param itemAccess {Array} - Список доступных статусов для одного элемента теблицы
 * @param t {Function} - Функция для переводов
 */
export const itemDropStatuses = (statuses, itemAccess = [], t) => {
  if (itemAccess === false) {
    return [];
  }

  return statuses.filter((item) => itemAccess.includes(item.id)).map((elem) => ({ id: elem.id, title: t(`ActionsList.${elem.title}`) }));
};

/**
 * @name checkTableCount
 * @param count {Number | String} - Проверка счетчика для start_count
 * @param tooltipText {String} - текст тултипа
 */
export const checkTableCount = (count, tooltipText) => {
  if (count && Number(count) === -1) {
    return { value: '', tooltip: !!tooltipText, tooltipText, icon: 'far fa-clock' };
  }

  if (count && Number(count) === -2) {
    return { value: '', tooltip: !!tooltipText, tooltipText, icon: 'far fa-times-circle' };
  }

  if (count && Number(count) === -3) {
    return { value: '', tooltip: !!tooltipText, tooltipText, icon: 'far fa-minus-circle' };
  }

  return { value: count, tooltip: false };
};

/**
 * @name prepareConfirmBtnsText
 * @param key {String} - Ключ события
 * @param actionType {Number} - Тип события
 */
export const prepareConfirmBtnsText = (key, actionType) => {
  if (actionType === 'single') {
    switch (key) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 7:
      return {
        confirmBtnText: 'Change',
        cancelBtnText: 'Close',
        submitStyle: 'primary',
      };

    default:
      return {
        confirmBtnText: '',
        cancelBtnText: '',
      };
    }
  }

  if (actionType === 'mass') {
    switch (key) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 7:
      return {
        confirmBtnText: 'Change',
        cancelBtnText: 'Close',
        submitStyle: 'primary',
      };

    default:
      return {
        confirmBtnText: '',
        cancelBtnText: '',
      };
    }
  }
};

export const getModesFilterName = (modes, filterSelected) => {
  if (filterSelected !== null) {
    const findMode = modes.find((mode) => {
      if (mode.id !== null) {
        if (Number(mode.id) === Number(filterSelected)) {
          return true;
        }
      }
      return false;
    });
    if (findMode) {
      return findMode.title.split(' ')[0];
    }
  }
  return 'Mode';
}

export const getSelectedServices = (services, selectedServices) => {
  if (services.length && selectedServices?.length) {
    return services.filter((service) => !!selectedServices.includes(Number(service.id)))
  }
  return []
}

export const getServicesFilterName = (services) => {
  if (isNull(services) || isUndefined(services) || !services.length) {
    return 'Service'
  }
  return `Service (${services.length})`
}
